import Section from '@/components/Section';
import Button from '@/components/Button';
import Reveal from '@/components/Reveal';
import { useQuote } from '@/components/QuoteDialog';
import { CONTACT_ITEMS, WORKING_HOURS, MAPS_EMBED, MAPS_LINK, FACEBOOK_URL } from '@/data/site';

export default function Contact() {
  const { openQuote } = useQuote();
  return (
    <Section id="kontakt" tone="dark">
      <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <span className="eyebrow mb-4 flex items-center gap-3 text-white/70">
            <span className="h-px w-8 bg-brand" aria-hidden="true" />
            Kontakt
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
            Vaš sljedeći projekat počinje ovdje.
          </h2>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-white/75">
            Pošaljite nam ideju, dimenzije ili fotografiju prostora i pomoći ćemo vam da pronađete
            odgovarajuće rješenje.
          </p>
          <Button onClick={() => openQuote()} data-testid="contact-cta" className="mt-10">
            Zatražite ponudu
          </Button>

          <div className="mt-12 border-t border-white/15 pt-6">
            <span className="eyebrow text-white/60">Radno vrijeme</span>
            <dl className="mt-3 space-y-1 text-white/85">
              {WORKING_HOURS.map(({ days, hours }) => (
                <div key={days} className="flex gap-4">
                  <dt className="w-24">{days}</dt>
                  <dd>{hours}</dd>
                </div>
              ))}
            </dl>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <ul className="divide-y divide-white/15 border-y border-white/15">
            {CONTACT_ITEMS.map(({ id, icon: Icon, label, value, href }) => {
              const external = href.startsWith('http');
              return (
                <li key={id}>
                  <a
                    href={href}
                    data-testid={`contact-${id}`}
                    {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                    className="group flex items-center gap-5 py-5"
                  >
                    <Icon className="h-5 w-5 shrink-0 text-white/60 group-hover:text-brand" aria-hidden="true" />
                    <span>
                      <span className="eyebrow block text-[0.65rem] text-white/60">{label}</span>
                      <span className="mt-1 block text-lg text-white/90 group-hover:text-white group-hover:underline underline-offset-4">
                        {value}
                      </span>
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>

      <div className="mt-16 flex flex-col gap-6 border-y border-white/15 py-8 lg:flex-row lg:items-center lg:justify-between" data-testid="review-cta">
        <div>
          <h3 className="text-xl sm:text-2xl">Radili smo zajedno?</h3>
          <p className="mt-2 text-white/75">Vaša ocjena i preporuka nam puno znače.</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Button href={MAPS_LINK} variant="outlineLight" data-testid="review-google">
            Ocijenite nas na Googleu
          </Button>
          <Button href={FACEBOOK_URL} variant="outlineLight" data-testid="review-facebook">
            Zapratite nas na Facebooku
          </Button>
        </div>
      </div>

      <div className="mt-10 h-[320px] w-full overflow-hidden bg-white/5">
        <iframe
          data-testid="google-map"
          title="Garmond Graphic — lokacija na mapi"
          src={MAPS_EMBED}
          className="h-full w-full"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </Section>
  );
}
